import classNames from 'classnames';
import CustomButton from 'components/customButton';
import useSaledPost from 'modules/myAdvertisment/hooks/useSaledPost';
import useDeleteAd from 'modules/myAdvertisment/myAdvertisment/deleteModal/deleteForm/hooks/useDeleteAd';
import React from 'react';
import SimpleDeleteReason from './simpleDeleteReason';
interface DeleteFormProps {
  app: 'farm' | 'wholesaler';
  isOpen: boolean;
  guid: string;
  postType: string;
  is_saled: boolean;
  setIsopen: (isOpen: boolean) => void;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const DeleteForm = ({
  app,
  guid,
  postType,
  is_saled,
  setIsopen,
  setChosedSugestionUser,
}: DeleteFormProps) => {
  const {mutate} = useDeleteAd({
    action: () => setIsopen(false),
  });
  const deletePost = () => {
    mutate({guid, delete_reason: 'successful', type: 'post'});
  };
  const {mutateSaled} = useSaledPost({action: deletePost});

  const deleteResonSuccess = () => {
    if (postType === 'auction' || postType === 'prepayment') {
      setIsopen(false);
      setChosedSugestionUser({
        guid: guid,
        isOpenModal: true,
        profile: null,
        type: postType,
        isDelete: true,
      });
    } else {
      mutateSaled({guid: guid});
    }
  };

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col w-full justify-center items-center gap-2">
        <div
          className={classNames(' bg-white p-4 rounded-full', {
            'absolute top-[-45px]  border-2 border-error  bg-error-1':
              app === 'wholesaler' ? true : false,
          })}
        >
          <span className="icon-error text-error text-[50px]" />
        </div>
        <h4
          className={classNames('text-gray-6 font-medium text-18px', {
            'mt-16 mb-8': app === 'wholesaler' ? true : false,
          })}
        >
          علت حذف آگهی را مشخص کنید
        </h4>
      </div>
      <div className="flex flex-col w-full gap-4">
        {!is_saled && (
          <>
            <button
              className=" text-center w-full py-3 bg-white border border-primary rounded-md text-primary"
              onClick={deleteResonSuccess}
            >
              متقاضی پیدا شد
            </button>
          </>
        )}
        <SimpleDeleteReason
          is_saled={is_saled}
          setIsopen={setIsopen}
          guid={guid}
        />
      </div>
      <CustomButton
        className={classNames({
          '!bg-error  !text-white': app === 'wholesaler' ? true : false,
          '!bg-error-1  !text-error': app === 'wholesaler' ? false : true,
        })}
        type="button"
        title="انصراف"
        onClick={() => setIsopen(false)}
      />
    </div>
  );
};

export default DeleteForm;
